export default class Share {
  init(twitterText) {
    this.text = twitterText || document.querySelector('title').textContent;
    this.url = window.location.href;
    this.buttons = document.querySelectorAll('[data-social-share]');
    if (this.buttons) {
      [].forEach.call(this.buttons, (item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(item.getAttribute('data-social-share'));
        });
      });
    }
  }

  open(network) {
    const windowObj = {
      winURL: false,
      winInit: false,
      winHeight: false,
      winWidth: false,
      winPosLeft: false,
      winPosTop: false,
    };

    switch (network) {
      case 'facebook':
        windowObj.winURL = `https://www.facebook.com/sharer/sharer.php?u=${this.url}`;
        windowObj.winHeight = 625;
        windowObj.winWidth = 600;
        break;
      case 'twitter':
        windowObj.winURL = `https://twitter.com/share?text=${this.text}&url=${this.url}`;
        windowObj.winHeight = 440;
        windowObj.winWidth = 600;
        break;
      case 'google':
        windowObj.winURL = `https://plus.google.com/share?url=${this.url}`;
        windowObj.winHeight = 465;
        windowObj.winWidth = 400;
        break;
      default:
        throw new Error(`Unsupported social network: ${network}`);
    }
    windowObj.winPosLeft = (window.screen.width / 2) - (windowObj.winWidth / 2);
    windowObj.winPosTop = (window.screen.height / 2) - (windowObj.winHeight / 2);
    windowObj.winInit = window.open(windowObj.winURL, 'sharing-popup', [
      `height=${windowObj.winHeight}`,
      `width=${windowObj.winWidth}`,
      `left=${windowObj.winPosLeft}`,
      `top=${windowObj.winPosTop}`,
    ].join(', '));
  }
}
